"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getGuid", {
  enumerable: true,
  get: function get() {
    return _getGuid["default"];
  }
});

var _getGuid = _interopRequireDefault(require("./getGuid"));